/** @jsxImportSource @emotion/react */

import { SerializedStyles } from "@emotion/serialize";
import React from "react";

type Props = {
  to: string;
  id?: string;
  css?: SerializedStyles;
  children: React.ReactNode;
  target?: "_blank";
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
};

export const ExternalLink: React.FC<Props> = React.memo(function ExternalLink({
  css,
  to,
  target,
  children,
  onClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.stopPropagation();
    // fall through the default behavior
  },
  ...props
}) {
  return (
    /* eslint-disable react/jsx-props-no-spreading */
    <a
      css={css}
      href={to}
      target={target}
      onClick={onClick}
      rel={target === "_blank" ? "noopener noreferrer" : undefined}
      {...props}
    >
      {children}
    </a>
    /* eslint-enable react/jsx-props-no-spreading */
  );
});
